<template>
  <div class="south_america_wrap">
    <div class="enter_img" :style="{'background': `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${pageData.bannerImage || require('../../assets/img/banner22.png')}) center/cover no-repeat`}">
      <div class="img_tit hidden-xs-only">{{ pageData.title || $t('southAmericaLine.title') }}</div>
      <div class="img_desc hidden-xs-only">
        {{ pageData.subTitle || $t('southAmericaLine.subtitle') }}
      </div>
      <div class="img_tit hidden-sm-and-up">
        {{ pageData.title || $t('southAmericaLine.title') }}<br />{{ pageData.subTitle || $t('southAmericaLine.subtitle') }}
      </div>
    </div>
    <div class="current_show_menu">
      <!-- 航线介绍区域 -->
      <div class="route_introduction">
        <div class="enter_title_wrap">
          <div class="enter_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center">
              <div class="enter_title">{{ $t('southAmericaLine.introduction.title') }}</div>
              <div class="enter_desc">{{ $t('southAmericaLine.introduction.description') }}</div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="introduction_content">
          <el-row :gutter="30" type="flex" justify="center">
            <el-col 
              v-for="(item, index) in introList" 
              :key="index" 
              :span="8" 
              :xs="24" 
              class="introduction_item"
            >
              <div class="introduction_card">
                <h3>{{ item.title }}</h3>
                <p>{{ item.content }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 航线图展示区域 -->
      <div class="route_map_wrap">
        <div class="enter_title_wrap">
          <div class="enter_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center">
              <div class="enter_title">{{ $t('southAmericaLine.network.title') }}</div>
              <div class="enter_desc">{{ $t('southAmericaLine.network.description') }}</div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="route_images">
          <div class="route_images_single">
            <div v-if="routeImages[0]" class="route_image_item_single">
              <div class="image_container_single">
                <img :src="routeImages[0]" alt="南美航线图1" />
              </div>
            </div>
            <div v-if="routeImages[1]" class="route_image_item_single">
              <div class="image_container_single">
                <img :src="routeImages[1]" alt="南美航线图2" />
              </div>
            </div>
            <div v-if="!routeImages[0] && !routeImages[1]" class="no-images-message">
              暂无航线图数据
            </div>
          </div>
        </div>
      </div>

      <!-- 服务优势 -->
      <div class="service_advantages">
        <div class="enter_title_wrap">
          <div class="enter_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center">
              <div class="enter_title">{{ $t('southAmericaLine.advantages.title') }}</div>
              <div class="enter_desc">{{ $t('southAmericaLine.advantages.description') }}</div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="advantages_content">
          <el-row :gutter="30" type="flex" justify="center">
            <el-col 
              v-for="(item, index) in advantageList" 
              :key="index" 
              :span="8" 
              :xs="24" 
              class="advantage_item"
            >
              <div class="advantage_card">
                <div class="advantage_icon">{{ ['🚢', '✈️', '🌎'][index] }}</div>
                <h3>{{ item.title }}</h3>
                <p>{{ item.desc }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 服务内容 -->
      <div class="service_content">
        <div class="enter_title_wrap">
          <div class="enter_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center">
              <div class="enter_title">{{ $t('southAmericaLine.services.title') }}</div>
              <div class="enter_desc">{{ $t('southAmericaLine.services.description') }}</div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="func_wrap">
          <div class="func_wrap_inner">
            <!-- 桌面端显示 -->
            <el-row class="func_card hidden-xs-only" type="flex">
              <el-col
                class="card_item"
                v-for="(item, index) in serviceList"
                :key="index"
                :span="5"
              >
                <div class="item_top" :style="{'background': item.bg}">
                  <p>{{ item.tit }}</p>
                </div>
                <div class="item_bottom">
                  <p v-for="(item2, index2) in item.desc" :key="index2">
                    {{ '○  ' + item2 }}
                  </p>
                </div>
              </el-col>
            </el-row>
            
            <!-- 移动端显示 -->
            <el-row class="func_card_mobile hidden-sm-and-up" type="flex" justify="center">
              <el-col
                class="card_item_mobile"
                v-for="(item, index) in serviceList"
                :key="index"
                :span="24"
              >
                <div class="item_top_mobile" :style="{'background': item.bg}">
                  <p>{{ item.tit }}</p>
                </div>
                <div class="item_bottom_mobile">
                  <p v-for="(item2, index2) in item.desc" :key="index2">
                    {{ '○  ' + item2 }}
                  </p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>

    <!-- 页面页脚 - 与首页一致 -->
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import CallMe from '../callme/index'
import MobileCallme from '../callme/MobileCallme.vue'
import { getSouthAmericaData } from '../../api/south-america'

export default {
  components: {
    CallMe,
    MobileCallme
  },
  data() {
    return {
      pageData: {
        title: '',
        subTitle: '',
        bannerImage: ''
      },
      routeImages: [],
      introList: [],
      advantageList: [],
      serviceList: [],
      loading: false
    }
  },
  methods: {
    getGradientColor(index) {
      const gradients = [
        'linear-gradient(135deg, #3498db, #2ecc71)',
        'linear-gradient(135deg, #e74c3c, #e67e22)',
        'linear-gradient(135deg, #9b59b6, #34495e)',
        'linear-gradient(135deg, #1abc9c, #16a085)'
      ];
      return gradients[index] || gradients[0];
    },
    
    // 获取完整图片URL
    getFullImageUrl(path) {
      if (!path) return '';
      // 如果已经是完整URL，直接返回
      if (path.startsWith('http')) return path;
      // 如果是相对路径，添加代理前缀
      return path;
    },
    
    // 加载南美专线数据
    async loadSouthAmericaData() {
      try {
        this.loading = true;
        console.log('开始加载南美专线数据...');
        // 获取当前语言
        const currentLanguage = localStorage.getItem('preferred-language') || 'zh-CN'
        const response = await getSouthAmericaData(currentLanguage);
        console.log('API响应:', response);
        
        if (response.data && response.data.data) {
          const data = response.data.data;
          console.log('后端数据:', data);
          
          // 设置横幅数据
          if (data.banner) {
            this.pageData = {
              title: data.banner.title,
              subTitle: data.banner.subTitle,
              bannerImage: this.getFullImageUrl(data.banner.bannerImage)
            };
            console.log('横幅数据设置完成:', this.pageData);
          }

          // 设置航线图数据
          if (data.routeImages) {
            const images = [];
            if (data.routeImages.image1) images.push(this.getFullImageUrl(data.routeImages.image1));
            if (data.routeImages.image2) images.push(this.getFullImageUrl(data.routeImages.image2));
            this.routeImages = images;
          }
          
          // 设置介绍数据
          if (data.intro && data.intro.length > 0) {
            this.introList = data.intro;
          } else {
            // 默认数据
            this.introList = [
              {
                title: '海运专线',
                content: '中国-南美海运专线主要覆盖巴西、智利、阿根廷、秘鲁等主要国家，航线通常从上海、宁波、深圳、青岛等港口出发，经太平洋抵达南美西海岸和东海岸港口。运输时间约30-45天，适合大宗商品、机械设备、电子产品等货物的运输。'
              },
              {
                title: '空运专线',
                content: '中国-南美空运专线通常经停北美或欧洲中转，最终抵达圣保罗、利马、布宜诺斯艾利斯等地，全程约15-25天。提供快速、安全的航空货运服务，适合高价值、时效性强的货物运输。'
              },
              {
                title: '全球网络',
                content: '南美专线的直接体现，连接南美资源国（如巴西的铁矿石、农产品）与中国制造业中心。覆盖南美区域内港口间的货物集散，提升区域物流效率，构建完整的全球物流网络。'
              }
            ];
          }
          
          // 设置优势数据
          if (data.advantage && data.advantage.length > 0) {
            this.advantageList = data.advantage;
          } else {
            // 默认数据
            this.advantageList = [
              {
                title: '时效保障',
                desc: '海运30-45天，空运15-25天，提供稳定的运输时效保障'
              },
              {
                title: '全程跟踪',
                desc: '提供货物全程实时跟踪服务，确保货物安全准时到达'
              },
              {
                title: '专业团队',
                desc: '拥有专业的南美物流团队，熟悉当地海关政策和物流环境'
              }
            ];
          }
          
          // 设置服务数据
          if (data.service && data.service.length > 0) {
            this.serviceList = data.service.map((item, index) => ({
              tit: item.title,
              desc: item.desc,
              bg: this.getGradientColor(index)
            }));
          } else {
            // 默认数据
            this.serviceList = [
              {
                tit: '海运专线',
                desc: [
                  '覆盖巴西、智利、阿根廷、秘鲁等主要国家',
                  '从上海、宁波、深圳、青岛等港口出发',
                  '运输时间30-45天，适合大宗商品',
                  '专业报关清关服务'
                ],
                bg: 'linear-gradient(135deg, #3498db, #2ecc71)'
              },
              {
                tit: '空运专线',
                desc: [
                  '经停北美或欧洲中转',
                  '抵达圣保罗、利马、布宜诺斯艾利斯',
                  '全程15-25天，时效性强',
                  '适合高价值货物运输'
                ],
                bg: 'linear-gradient(135deg, #e74c3c, #e67e22)'
              },
              {
                tit: '铁路运输',
                desc: [
                  '多式联运解决方案',
                  '连接内陆城市与港口',
                  '成本优化运输方案',
                  '灵活多样的运输方式'
                ],
                bg: 'linear-gradient(135deg, #9b59b6, #34495e)'
              },
              {
                tit: '仓储配送',
                desc: [
                  '南美本地仓储服务',
                  '最后一公里配送',
                  '库存管理系统',
                  '订单处理中心'
                ],
                bg: 'linear-gradient(135deg, #1abc9c, #16a085)'
              }
            ];
          }
        }
      } catch (error) {
        console.error('加载南美专线数据失败:', error);
        // 使用默认数据
        this.setDefaultData();
      } finally {
        this.loading = false;
      }
    },
    
    // 设置默认数据
    setDefaultData() {
      this.introList = [
        {
          title: '海运专线',
          content: '中国-南美海运专线主要覆盖巴西、智利、阿根廷、秘鲁等主要国家，航线通常从上海、宁波、深圳、青岛等港口出发，经太平洋抵达南美西海岸和东海岸港口。运输时间约30-45天，适合大宗商品、机械设备、电子产品等货物的运输。'
        },
        {
          title: '空运专线',
          content: '中国-南美空运专线通常经停北美或欧洲中转，最终抵达圣保罗、利马、布宜诺斯艾利斯等地，全程约15-25天。提供快速、安全的航空货运服务，适合高价值、时效性强的货物运输。'
        },
        {
          title: '全球网络',
          content: '南美专线的直接体现，连接南美资源国（如巴西的铁矿石、农产品）与中国制造业中心。覆盖南美区域内港口间的货物集散，提升区域物流效率，构建完整的全球物流网络。'
        }
      ];
      
      this.advantageList = [
        {
          title: '时效保障',
          desc: '海运30-45天，空运15-25天，提供稳定的运输时效保障'
        },
        {
          title: '全程跟踪',
          desc: '提供货物全程实时跟踪服务，确保货物安全准时到达'
        },
        {
          title: '专业团队',
          desc: '拥有专业的南美物流团队，熟悉当地海关政策和物流环境'
        }
      ];
      
      this.serviceList = [
        {
          tit: '海运专线',
          desc: [
            '覆盖巴西、智利、阿根廷、秘鲁等主要国家',
            '从上海、宁波、深圳、青岛等港口出发',
            '运输时间30-45天，适合大宗商品',
            '专业报关清关服务'
          ],
          bg: 'linear-gradient(135deg, #3498db, #2ecc71)'
        },
        {
          tit: '空运专线',
          desc: [
            '经停北美或欧洲中转',
            '抵达圣保罗、利马、布宜诺斯艾利斯',
            '全程15-25天，时效性强',
            '适合高价值货物运输'
          ],
          bg: 'linear-gradient(135deg, #e74c3c, #e67e22)'
        },
        {
          tit: '铁路运输',
          desc: [
            '多式联运解决方案',
            '连接内陆城市与港口',
            '成本优化运输方案',
            '灵活多样的运输方式'
          ],
          bg: 'linear-gradient(135deg, #9b59b6, #34495e)'
        },
        {
          tit: '仓储配送',
          desc: [
            '南美本地仓储服务',
            '最后一公里配送',
            '库存管理系统',
            '订单处理中心'
          ],
          bg: 'linear-gradient(135deg, #1abc9c, #16a085)'
        }
      ];
    }
  },
  mounted() {
    this.loadSouthAmericaData();
  },
}
</script>

<style lang="scss" scoped>
.south_america_wrap {
  width: 100%;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  
  .enter_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    text-align: center;
    
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
      margin-bottom: 20px;
      @media screen and (max-width: 768px) {
        font-size: 1.8rem;
        margin-bottom: 15px;
      }
    }
    .img_desc {
      font-size: 28px;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
      max-width: 800px;
      line-height: 1.4;
      @media screen and (max-width: 768px) {
        font-size: 1rem;
        padding: 0 20px;
      }
    }
  }

  .enter_title_wrap {
    width: 100%;
    margin-top: 80px;
    @media screen and (max-width: 768px) {
      margin-top: 50px;
    }
    
    .enter_inner {
      display: flex;
      justify-content: center;
      align-items: center;
      
      .inner_left, .inner_right {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        
        img {
          width: 80px;
          height: 80px;
          opacity: 0.7;
          @media screen and (max-width: 768px) {
            width: 40px;
            height: 40px;
          }
        }
      }
      
      .inner_center {
        flex: 2;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 40px;
        
        .enter_title {
          font-size: 42px;
          font-weight: bold;
          color: #2c3e50;
          margin-bottom: 15px;
          position: relative;
          
          &::after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 80px;
            height: 3px;
            background: linear-gradient(90deg, #3498db, #2ecc71);
            border-radius: 2px;
          }
          
          @media screen and (max-width: 768px) {
            font-size: 1.5rem;
          }
        }
        
        .enter_desc {
          font-size: 18px;
          color: #7f8c8d;
          text-align: center;
          line-height: 1.6;
          margin-top: 25px;
          @media screen and (max-width: 768px) {
            font-size: 0.9rem;
            margin-top: 15px;
          }
        }
      }
    }
  }

  .current_show_menu {
    padding: 60px 0;
    
    .route_introduction {
      .introduction_content {
        width: 90%;
        max-width: 1200px;
        margin: 60px auto;
        @media screen and (max-width: 768px) {
          width: 95%;
          margin: 40px auto;
        }
        
        .introduction_item {
          margin-bottom: 40px;
          
          .introduction_card {
            background: linear-gradient(145deg, #ffffff, #f8f9fa);
            border-radius: 20px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
            padding: 40px 30px;
            height: 100%;
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            border: 1px solid rgba(255, 255, 255, 0.8);
            position: relative;
            overflow: hidden;
            
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              height: 4px;
              background: linear-gradient(90deg, #3498db, #2ecc71);
            }
            
            &:hover {
              transform: translateY(-10px) scale(1.02);
              box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
            }
            
            h3 {
              font-size: 26px;
              font-weight: bold;
              color: #2c3e50;
              margin-bottom: 25px;
              text-align: center;
              position: relative;
              
              &::after {
                content: '';
                position: absolute;
                bottom: -8px;
                left: 50%;
                transform: translateX(-50%);
                width: 40px;
                height: 2px;
                background: #3498db;
              }
              
              @media screen and (max-width: 768px) {
                font-size: 22px;
              }
            }
            
            p {
              font-size: 16px;
              line-height: 1.8;
              color: #5d6d7e;
              margin-bottom: 20px;
              text-align: justify;
              
              @media screen and (max-width: 768px) {
                font-size: 14px;
                line-height: 1.6;
              }
            }
          }
        }
      }
    }

    .route_map_wrap {
      .route_images {
        width: 90%;
        max-width: 1200px;
        margin: 60px auto;
        @media screen and (max-width: 768px) {
          width: 95%;
          margin: 40px auto;
        }
        
        .route_images_single {
          display: flex;
          flex-direction: column;
          gap: 60px;
          
          .route_image_item_single {
            margin-bottom: 0;
            
            .image_container_single {
              background: #fff;
              border-radius: 20px;
              box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
              overflow: hidden;
              transition: all 0.4s ease;
              border: 1px solid rgba(255, 255, 255, 0.8);
              
              &:hover {
                transform: translateY(-10px);
                box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
              }
              
              img {
                width: 100%;
                height: 600px;
                object-fit: contain;
                transition: transform 0.4s ease;
                
                &:hover {
                  transform: scale(1.03);
                }
                
                @media screen and (max-width: 768px) {
                  height: 400px;
                }
              }
              
              .image_title_single {
                padding: 25px;
                text-align: center;
                font-size: 24px;
                font-weight: bold;
                color: #2c3e50;
                background: linear-gradient(135deg, #f8f9fa, #e9ecef);
                border-top: 1px solid #e9ecef;
                
                @media screen and (max-width: 768px) {
                  font-size: 20px;
                  padding: 20px;
                }
              }
            }
          }
          
          .no-images-message {
            text-align: center;
            padding: 60px;
            font-size: 18px;
            color: #7f8c8d;
            background: #f8f9fa;
            border-radius: 15px;
            border: 2px dashed #dee2e6;
          }
        }
      }
    }

    .service_advantages {
      .advantages_content {
        width: 90%;
        max-width: 1200px;
        margin: 60px auto;
        @media screen and (max-width: 768px) {
          width: 95%;
          margin: 40px auto;
        }
        
        .advantage_item {
          margin-bottom: 40px;
          
          .advantage_card {
            background: linear-gradient(145deg, #ffffff, #f8f9fa);
            border-radius: 20px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
            padding: 40px 30px;
            height: 100%;
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            border: 1px solid rgba(255, 255, 255, 0.8);
            text-align: center;
            position: relative;
            overflow: hidden;
            
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              height: 4px;
              background: linear-gradient(90deg, #3498db, #2ecc71);
            }
            
            &:hover {
              transform: translateY(-10px) scale(1.02);
              box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
            }
            
            .advantage_icon {
              font-size: 60px;
              margin-bottom: 25px;
              display: block;
              transition: transform 0.3s ease;
            }
            
            &:hover .advantage_icon {
              transform: scale(1.1);
            }
            
            h3 {
              font-size: 24px;
              font-weight: bold;
              color: #2c3e50;
              margin-bottom: 20px;
              position: relative;
              
              &::after {
                content: '';
                position: absolute;
                bottom: -8px;
                left: 50%;
                transform: translateX(-50%);
                width: 40px;
                height: 2px;
                background: #3498db;
              }
              
              @media screen and (max-width: 768px) {
                font-size: 20px;
              }
            }
            
            p {
              font-size: 16px;
              line-height: 1.6;
              color: #5d6d7e;
              margin: 0;
              
              @media screen and (max-width: 768px) {
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }

  .func_wrap {
    width: 100%;
    padding: 80px 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    min-height: 400px;
    
    .func_wrap_inner {
      width: 90%;
      max-width: 1200px;
      margin: 0 auto;
      @media screen and (max-width: 768px) {
        width: 95%;
      }
      
      .func_card {
        justify-content: space-between;
        margin-top: 50px;
        
        .card_item {
          background: rgba(255, 255, 255, 0.95);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
          border-radius: 20px;
          overflow: hidden;
          transition: all 0.4s ease;
          border: 1px solid rgba(255, 255, 255, 0.8);
          
          &:hover {
            transform: translateY(-10px);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
          }
          
          .item_top {
            width: 100%;
            height: 180px;
            font-size: 26px;
            font-weight: bold;
            color: #fff;
            background: linear-gradient(135deg, #3498db, #2ecc71);
            background-size: cover;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            overflow: hidden;
            
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: rgba(0, 0, 0, 0.1);
            }
            
            p {
              position: relative;
              z-index: 2;
              text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
            }
          }
          
          .item_bottom {
            padding: 25px 20px;
            
            p {
              font-size: 16px;
              margin-top: 15px;
              color: #5d6d7e;
              line-height: 1.6;
              position: relative;
              padding-left: 20px;
              
              &::before {
                content: '●';
                position: absolute;
                left: 0;
                color: #3498db;
                font-weight: bold;
              }
            }
          }
        }
      }

      .func_card_mobile {
        margin-top: 30px;
        
        .card_item_mobile {
          margin-bottom: 20px;
          
          .item_top_mobile {
            width: 100%;
            height: 120px;
            font-size: 20px;
            font-weight: bold;
            color: #fff;
            background: linear-gradient(135deg, #3498db, #2ecc71);
            background-size: cover;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            overflow: hidden;
            border-radius: 15px 15px 0 0;
            
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: rgba(0, 0, 0, 0.1);
            }
            
            p {
              position: relative;
              z-index: 2;
              text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
            }
          }
          
          .item_bottom_mobile {
            background: rgba(255, 255, 255, 0.95);
            padding: 20px 15px;
            border-radius: 0 0 15px 15px;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
            
            p {
              font-size: 14px;
              margin-top: 10px;
              color: #5d6d7e;
              line-height: 1.5;
              position: relative;
              padding-left: 15px;
              
              &::before {
                content: '●';
                position: absolute;
                left: 0;
                color: #3498db;
                font-weight: bold;
              }
            }
          }
        }
      }
    }
  }
}
</style>
